import {
  CometChatUIKit,
  UIKitSettingsBuilder,
} from "@cometchat/chat-uikit-react";

import { __IS_DEV__ } from "./env";

/**
 * CometChat application constants
 * @constant {Object} COMETCHAT_CONSTANTS
 * @property {string} APP_ID - CometChat application ID
 * @property {string} REGION - CometChat region
 * @property {string} AUTH_KEY - CometChat authentication key
 */
export const COMETCHAT_CONSTANTS = {
  APP_ID: "279090c82207e947",
  REGION: "in",
  AUTH_KEY: __IS_DEV__ ? "959add1403c5a50760fcecb4f94a5eec04a17f97" : "",
  FCM_PROVIDER_ID: "firebase-adminsdk-fbsvc@sip-chat-staging"
};

export const getSipTokenStorageKey = (id = COMETCHAT_CONSTANTS.APP_ID) => {
  return `${id}:sip/token`
}

export const buildUiKitSettings = (authKey?: string) => {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(COMETCHAT_CONSTANTS.APP_ID)
    .setRegion(COMETCHAT_CONSTANTS.REGION)
    .setAuthKey(authKey || COMETCHAT_CONSTANTS.AUTH_KEY)
    .subscribePresenceForAllUsers()
    .build();

  CometChatUIKit.uiKitSettings = uiKitSettings;

  return uiKitSettings;
};
